(function () {
  function initImmershopWhatsApp() {
    const widget = document.getElementById('immershop-wa-widget');
    const panel = document.getElementById('immershop-wa-panel');
    const trigger = document.getElementById('immershop-wa-trigger');
    const closeButton = document.getElementById('immershop-wa-close');
    const tooltip = document.getElementById('immershop-wa-tooltip');
    const statusText = document.getElementById('immershop-wa-status-text');
    const statusDot = document.getElementById('immershop-wa-status-dot');

    if (!widget || !panel || !trigger || !closeButton) return;
    if (widget.dataset.whatsappInitialized === 'true') return;
    widget.dataset.whatsappInitialized = 'true';

    const tooltipSessionKey = 'immershopWhatsappHelpBubbleShown';
    let tooltipShowTimer;
    let tooltipHideTimer;

    function rememberTooltip() {
      try {
        sessionStorage.setItem(tooltipSessionKey, 'true');
      } catch (error) {}
    }

    function hideTooltip(cancelPending) {
      if (!tooltip) return;
      tooltip.classList.remove('is-visible');
      tooltip.setAttribute('aria-hidden', 'true');
      window.clearTimeout(tooltipHideTimer);
      if (cancelPending) window.clearTimeout(tooltipShowTimer);
    }

    function openPanel() {
      rememberTooltip();
      hideTooltip(true);
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function togglePanel() {
      panel.classList.contains('is-open') ? closePanel() : openPanel();
    }

    function showTooltip() {
      rememberTooltip();
      if (!tooltip || panel.classList.contains('is-open')) return;

      tooltip.classList.add('is-visible');
      tooltip.setAttribute('aria-hidden', 'false');
      window.clearTimeout(tooltipHideTimer);
      tooltipHideTimer = window.setTimeout(function () {
        hideTooltip(false);
      }, 5000);
    }

    function updateAvailabilityStatus() {
      if (!statusText || !statusDot) return;

      try {
        const parts = new Intl.DateTimeFormat('it-IT', {
          timeZone: 'Europe/Rome',
          hour: '2-digit',
          weekday: 'short',
          hour12: false,
        }).formatToParts(new Date());
        const hour = Number(parts.find((part) => part.type === 'hour').value);
        const weekday = parts.find((part) => part.type === 'weekday').value.toLowerCase();
        const isOnline = !weekday.startsWith('dom') && hour >= 9 && hour < 19;

        statusText.textContent = isOnline
          ? 'Online ora'
          : 'Al momento offline — scrivici comunque';
        statusDot.classList.toggle('is-offline', !isOnline);
      } catch (error) {
        statusText.textContent = 'Scrivici su WhatsApp';
      }
    }

    closePanel();
    updateAvailabilityStatus();

    trigger.addEventListener('click', togglePanel);
    closeButton.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });

    document.addEventListener('click', function (event) {
      if (panel.classList.contains('is-open') && !widget.contains(event.target)) {
        closePanel();
      }
    });

    if (tooltip) {
      tooltip.innerHTML = '<strong>Hai bisogno di aiuto?</strong><span class="immershop-wa-tooltip-subline">Scrivici su WhatsApp</span>';
      tooltip.setAttribute('role', 'button');
      tooltip.setAttribute('tabindex', '0');
      tooltip.setAttribute('aria-label', 'Hai bisogno di aiuto? Scrivici su WhatsApp');
      tooltip.setAttribute('aria-hidden', 'true');

      tooltip.addEventListener('click', openPanel);
      tooltip.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openPanel();
        }
      });

      let tooltipAlreadyShown = false;
      try {
        tooltipAlreadyShown = sessionStorage.getItem(tooltipSessionKey) === 'true';
      } catch (error) {}

      if (!tooltipAlreadyShown) {
        tooltipShowTimer = window.setTimeout(showTooltip, 6000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImmershopWhatsApp, { once: true });
  } else {
    initImmershopWhatsApp();
  }
})();
